import { extractBlobAssetKey } from '@/helpers/preview/blob-asset-key.helper';
import { collectOutputLayerTrackSids } from '@/helpers/resolve-output-preview-layers';

type StillFrameKeyLayer = {
  layerId: number;
  componentId: string;
  itemId?: string;
  trackSid?: string;
  trackSids?: string[];
  data?: Record<string, string | undefined> | null;
};

/**
 * Fingerprint for StillFrameReadyProvider resets.
 * Includes LiveKit track SIDs / itemIds — url-only keys stayed identical across cue advances
 * and left Control Now/Next stuck on `contentReady=false`.
 */
export function buildStillFrameLayersResetKey(layers: StillFrameKeyLayer[], resetNonce = 0): string {
  const layerKey = layers
    .map((layer) => {
      const mediaUrl = extractBlobAssetKey(layer.data?.videoUrl ?? layer.data?.url ?? '');
      const trackSids = collectOutputLayerTrackSids(layer).join(',');
      return [layer.layerId, layer.componentId, layer.itemId ?? '', trackSids, mediaUrl].join(':');
    })
    .join('|');
  return `${resetNonce}::${layerKey}`;
}
